import Api from "./api";
import OidcManager from "./oidcManager";

export interface Account {
    paymentRequired: boolean;
}

export class AccountsApi extends Api {

    public constructor(oidc: OidcManager, address: string) {
        super(oidc, address)
    }

    check(): JQueryPromise<Account> {
        return super.get("/api/account/",{});
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/accounts.ts